import { useState } from "react";
import { MGButton, SearchInput, MGDatePicker } from "../../../components";

// Third party
import { GridCsvExportOptions, useGridApiContext } from "@mui/x-data-grid";
import { Menu, MenuItem } from "@mui/material";
import { FiDownload } from "react-icons/fi";
import { addDays, differenceInDays } from "../../../utils/date.utils";

export const PastToolbar = ({
  searchParams,
  handleSearchParam,
  startDate,
  endDate,
  handleStartDate,
  handleEndDate,
  exportOptions,
}: any) => {
  const apiRef = useGridApiContext();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleExportCsv = () => {
    const fileName = exportOptions?.fileName;
    const options: GridCsvExportOptions = {
      fileName: `${fileName}.csv`,
      delimiter: ",",
      allColumns: true,
      utf8WithBom: true,
    };
    apiRef.current?.exportDataAsCsv(options);
    setAnchorEl(null);
  };

  // Excel Export Handler
  const handleExportExcel = () => {
    const fileName = exportOptions?.fileName;
    const options: GridCsvExportOptions = {
      fileName: `${fileName}.xlsx`,
      delimiter: ",",
      utf8WithBom: true,
      allColumns: true,
    };

    if (apiRef?.current) {
      apiRef.current?.exportDataAsCsv(options);
    }
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const yesterday = addDays(new Date(), -1);

  const handleStartDateChange = (date: Date | null) => {
    if (date) {
      const validDate = date > yesterday ? yesterday : date;
      handleStartDate(validDate);
    }
  };

  const handleEndDateChange = (date: Date | null) => {
    if (date) {
      const validDate = date > yesterday ? yesterday : date;
      handleEndDate(validDate);
    }
  };

  return (
    <div className="search-input">
      <SearchInput
        className="search-field"
        placeholder="Search by TM ID"
        value={searchParams}
        onChange={handleSearchParam}
      />

      <div style={{ marginTop: -8 }}>
        <MGDatePicker
          containerClassName="flex-row"
          label="Start Date"
          dateFormat="MM/dd/yyyy"
          onChange={handleStartDateChange}
          selected={startDate}
          maxDate={
            endDate ? (endDate > yesterday ? yesterday : endDate) : yesterday
          }
          filterDate={(date) => {
            if (date > yesterday) return false;

            if (endDate) {
              const daysDiff = differenceInDays(endDate, date);
              if (daysDiff > 60) return false;
            }

            return true;
          }}
        />
      </div>

      <div style={{ marginTop: -8 }}>
        <MGDatePicker
          containerClassName="flex-row"
          label="End Date"
          dateFormat="MM/dd/yyyy"
          onChange={handleEndDateChange}
          selected={endDate}
          minDate={startDate}
          maxDate={yesterday}
          filterDate={(date) => {
            if (date > yesterday) return false;

            if (startDate) {
              const daysDiff = differenceInDays(date, startDate);
              if (daysDiff > 60) return false;
            }

            return true;
          }}
        />
      </div>

      <MGButton className="export-button" onClick={handleClick}>
        <FiDownload style={{ marginRight: 4 }} className="assign-icon" />
        <span>Export</span>
      </MGButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleExportCsv}>Download as CSV</MenuItem>
        <MenuItem onClick={handleExportExcel}>Download as Excel</MenuItem>
      </Menu>
    </div>
  );
};
